import { Badge } from '@kgc/ui';
import { ArrowRight } from 'lucide-react';

interface VersionBadgeProps {
  label: string;
  version: string;
  onClick: (version: string) => void;
}

export function VersionBadge({ label, version, onClick }: VersionBadgeProps) {
  return (
    <Badge
      variant="outline"
      className="cursor-pointer gap-1 hover:bg-accent"
      onClick={e => {
        e.stopPropagation();
        onClick(version);
      }}
    >
      {label}
      <ArrowRight className="h-3 w-3" />
    </Badge>
  );
}
